import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { HelpOutline } from '@mui/icons-material'
import { RootState } from '../../store/redux/store'
import { Tooltip, Box, Popover, Typography } from '@mui/material'
import { StyledIconButtonInfo } from '../../styles/PageHeaderStyles'
import { getInfoPopupContent } from '../../store/redux/reducers/pageHeaderSlice'
import WorklogViewInfo from '../Sidebar/info/worklog/WorklogViewInfo'

export type InfoContentOption = 'WORKLOG' | 'OTHER'

const popupContent: Record<InfoContentOption, React.ReactNode> = {
  WORKLOG: <WorklogViewInfo />,
  OTHER: undefined,
}

const InfoButton = () => {
  // TRANSLATION
  const { t } = useTranslation()

  // STATE
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  // CONTENT
  const contentID = useSelector((state: RootState) => getInfoPopupContent(state))

  // CLICK HANDLERS
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box>
      <Tooltip title={t('components.tooltip.info')} placement="bottom">
        <StyledIconButtonInfo onClick={e => handleOpen(e)}>
          <HelpOutline sx={{}} />
        </StyledIconButtonInfo>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleClose()}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{}}
      >
        <Box sx={{ width: '100%', height: '100%', padding: 2 }}>
          {contentID !== undefined ? (
            popupContent[contentID]
          ) : (
            <Typography variant="caption">{t('components.popup.error')}</Typography>
          )}
        </Box>
      </Popover>
    </Box>
  )
}

export default InfoButton
